
import { useEffect, useState } from "react";
import { useLocation, useNavigate, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Badge from "@mui/material/Badge";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MaterialBox from "../../../../components/MaterialBox";
import {
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController,
} from "../../../../context";
import { navbar, navbarContainer, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import EmailIcon from "@mui/icons-material/Email";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useAuth } from "../../../../context/AuthContext";
import { BASE_URL } from "../../../../pages/Utils/Baseurl";
import { Button, Card, Drawer, Stack } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import axios from "axios";
import routes from "../../../../routes";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [notificationAnchor, setNotificationAnchor] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const openNotifications = Boolean(notificationAnchor);
  const location = useLocation();
  const { pathname } = location;
  const route = pathname.split("/").slice(1);
  const { logout } = useAuth();

  const findActiveModuleGroup = (items) => {
    for (const item of items) {
      if (item.collapse) {
        if (item.collapse.some((c) => c.route === pathname)) {
          return item;
        }
        const found = findActiveModuleGroup(item.collapse);
        if (found) return found;
      }
    }
    return null;
  };

  const activeModule = findActiveModuleGroup(routes);
  const subModules = activeModule ? activeModule.collapse : [];
  const [user, setUser] = useState({
    name: "Ajith Kumar",
    picture: "",
    email: "",
    role: "",
  });
  const [pageState, setPageState] = useState({ state: "init" });
  const currentUser = sessionStorage.getItem("currentUser");
  const userName = JSON.parse(sessionStorage.getItem("first_name"));
  const userEmail = JSON.parse(sessionStorage.getItem("email"));
  const user_profile_image = JSON.parse(sessionStorage.getItem("profile_image"));

  useEffect(() => {
    const getUser = () => {
      setUser({
        name: currentUser?.employee_name,
        email: currentUser?.email,
        picture: currentUser?.profile_image
          ? `${BASE_URL}${currentUser?.profile_image}`
          : null,
        role: currentUser?.role?.role,
      });
      setPageState({ state: "default" });
    };
    getUser();
  }, [currentUser]);

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    const handleTransparentNavbar = () => {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    };

    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  useEffect(() => {
    fetchNotifications();
  }, [])

  const fetchNotifications = async () => {
    try {
      const token = sessionStorage.getItem('token');

      const response = await axios.post(
        `${BASE_URL}api/getnotifications/`, { user_id: currentUser },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNotifications(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };


  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const handleNotificationClick = (event) =>
    setNotificationAnchor(event.currentTarget);
  const handleNotificationClose = () => setNotificationAnchor(null);

  const handleViewAll = () => {
    setDrawerOpen(true);
    handleNotificationClose();
  };

  const handleNotificationDelete = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.post(`${BASE_URL}api/clearnotification/`, { user_id: currentUser }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setNotifications([]);
    } catch (error) {
      console.log(error);
    }
  }

  const handleTaskClick = (item) => {
    alert(`Clicked notification: ${item.projectName}`);
  };

  const signOut = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const refreshToken = sessionStorage.getItem("refresh_token");

      if (token && refreshToken) {
        await axios.post(`${BASE_URL}api/logout/`, {
          refresh_token: refreshToken
        }, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
      }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      await logout();
      sessionStorage.clear();
      navigate('/sign-in');
    }
  };

  const renderUserMenu = () => (
    <Menu
      anchorEl={openMenu}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      sx={{ mt: 1 }}
    >
      <NotificationItem id="logout" icon={<EmailIcon sx={{ color: "#1E297B" }} />} title={userEmail} />
      <NotificationItem
        id="role"
        icon={<PermIdentityIcon sx={{ color: "#1E297B" }} />}
        title={userName}
      />
      <NotificationItem
        id="logout"
        onClick={signOut}
        icon={<LogoutIcon sx={{ color: "red" }} />}
        title={"Logout"}
      />
    </Menu>
  );

  const renderNotificationMenu = () => (
    <Menu
      anchorEl={notificationAnchor}
      open={openNotifications}
      onClose={handleNotificationClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      sx={{ mt: 2 }}
    >
      <MaterialBox
        sx={{
          paddingRight: 2,
          paddingLeft: 2,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <MaterialTypography
          variant="h6"
          color="dark"
          fontWeight="bold"
          sx={{ fontSize: "16px" }}
        >
          Notifications
        </MaterialTypography>

      </MaterialBox>
      {notifications.length === 0 && (
        <Typography
          variant="body2"
          sx={{
            fontSize: "12px",
            color: "gray",
            textAlign: "center",
            mt: 2,
          }}
        >
          No notifications
        </Typography>
      )}
      {notifications.slice(0, 3).map((item) => (
        <MenuItem key={item.id} sx={{ whiteSpace: "normal", maxWidth: 320 }}>
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              color="dark"
              sx={{ fontSize: "14px" }}
            >
              {item.title}
            </Typography>
            <Typography variant="body2" color="text" sx={{ fontSize: "12px" }}>
              {item.body}
            </Typography>
          </Box>
        </MenuItem>
      ))}
      {notifications.length > 0 && (
        <MaterialBox
          sx={{
            mt: 1,
            paddingRight: 2,
            paddingLeft: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            size="small"
            // endIcon={<KeyboardDoubleArrowRightIcon />}
            onClick={handleViewAll}
            sx={{
              mr: 1,
              backgroundColor: '#FFE0B2',
              color: '#E65100',
              '&:hover': {
                backgroundColor: '#FFCC80',
              },
            }}
          >
            View All
          </Button>
          <Button
            variant="contained"
            size="small"
            // endIcon={<DeleteIcon />}
            sx={{
              backgroundColor: '#FFCDD2',
              color: '#C62828',
              '&:hover': {
                backgroundColor: '#EF9A9A',
              },
            }}
            onClick={handleNotificationDelete}
          >
            Clear All
          </Button>
        </MaterialBox>
      )}
    </Menu>
  );

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {pageState.state === "default" && (
          <>
            <MaterialBox display="flex" flexDirection="column" flexGrow={1}>
              {subModules.length > 0 && (
                <MaterialBox
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  sx={{
                    overflowX: "auto",
                    "&::-webkit-scrollbar": { display: "none" },
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                    mb: 0.5
                  }}
                >
                  {subModules.map((s) => (
                    <NavLink
                      key={s.key}
                      to={s.route}
                      style={{ textDecoration: "none" }}
                    >
                      <MaterialTypography
                        variant="button"
                        fontWeight={pathname === s.route ? "bold" : "regular"}
                        color={pathname === s.route ? "info" : "dark"}
                        sx={{
                          mx: 1.2,
                          fontSize: "12px",
                          textTransform: "none",
                          color: pathname === s.route ? "#6371c2" : "dark",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                          borderBottom: pathname === s.route ? "2px solid" : "none",
                          borderColor: "#6371c2",
                          pb: 0.5,
                          transition: "all 300ms ease-in-out",
                          "&:hover": {
                            color: "#6371c2",
                          }
                        }}
                      >
                        {s.name.trim().charAt(0).toUpperCase() + s.name.trim().slice(1).toLowerCase()}
                      </MaterialTypography>
                    </NavLink>
                  ))}
                </MaterialBox>
              )}

              <MaterialBox display="flex" alignItems="center">
                <Icon
                  fontSize="medium"
                  onClick={handleMiniSidenav}
                  sx={{ cursor: "pointer", mt: 0.3, display: { xs: "block", xl: "none" } }}
                >
                  {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                </Icon>
                <MaterialBox ml={1}>
                  <Breadcrumbs
                    icon={<HomeIcon />}
                    title={route[route.length - 1]}
                    route={route}
                    light={light}
                  />
                </MaterialBox>
              </MaterialBox>
            </MaterialBox>

            {!isMini && (
              <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
                <IconButton
                  color="inherit"
                  onClick={handleNotificationClick}
                  sx={{
                    mr: 2.5,
                    bgcolor: "background.paper",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
                    borderRadius: "50%",
                    width: 30,
                    height: 30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "black",

                  }}
                >
                  <Badge
                    badgeContent={notifications.length}
                    color="error"
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                      size: "small",
                    }}
                  >
                    <NotificationsIcon sx={{ color: "#5c6cbf" }} />
                  </Badge>
                </IconButton>
                {renderNotificationMenu()}
                <IconButton
                  onClick={handleOpenMenu}
                  size="small"
                  aria-controls={openMenu ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMenu ? "true" : undefined}
                >
                  <MaterialAvatar
                    alt={user.name}
                    src={user_profile_image}
                    sx={{
                      width: 30,
                      height: 30,
                      "& img": {
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      },
                    }}
                  />
                </IconButton>
                {renderUserMenu()}
              </MaterialBox>
            )}
          </>
        )}
      </Toolbar>
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box
          sx={{
            width: 250,
            padding: 1,
            height: "100vh",
            boxSizing: "border-box",
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
          role="presentation"
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            All Notifications
          </Typography>

          {notifications.length === 0 && (
            <Typography
              variant="body2"
              sx={{
                fontSize: "12px",
                color: "gray",
                textAlign: "center",
                mt: 2,
              }}
            >
              No notifications
            </Typography>
          )}

          {notifications.map((item) => (
            <Card
              key={item.id}
              variant="outlined"
              sx={{
                mb: 1,
                cursor: "pointer",
                p: 1,
                width: "230px",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 2,
                },
              }}
              onClick={() => {
                handleTaskClick(item);
                setDrawerOpen(false);
              }}
            >
              <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color="dark"
                  sx={{ fontSize: "12px" }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color="dark"
                  sx={{ fontSize: "8px" }}
                >
                  {new Date(item.created_at).toISOString().split('T')[0]}
                </Typography>
              </Stack>
              <Typography
                variant="body2"
                color="text"
                sx={{
                  fontSize: "12px",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {item.body}
              </Typography>
            </Card>
          ))}
        </Box>
      </Drawer>
    </AppBar >
  );
}

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;